/* capini-model-gate.js v2.2 (07/09/2026 · canal trafego, Galileu) — substitui a v1 do CS/site de 06/09.
   v1 derrubou a loja no celular por ~18 h (06/09 23:31 -> 07/09 11:39): o MutationObserver chamava aplicar() a cada mutacao e
   aplicar() reescrevia o aviso (mutacao) -> laco infinito; medido em 07/09: no tema de teste 166428737756 a pagina TRAVA
   (evaluate nunca volta); na v2 0 mutacoes/s e 0 tarefas longas. v2.1: sem deteccao por texto (Google Tradutor reescreve o
   rotulo). v2.2: a lista de opcoes (x-popover) fica no <body>, fora do fieldset -> ponte pelo aria-controls; escolher o MESMO
   modelo pre-selecionado (iPhone 17) nao dispara change no tema -> so o clique na opcao conta; variant:change so apos gesto real.
   Testado 07/09 no rascunho 166456885468 (iPhone sem tela, clarity.js falso bloqueado): sem gesto = travado 10 s; mesmo modelo =
   destrava; outro modelo = destrava + variant id muda.
   v2.3 (10/09/2026 · canal site, Jobs): a trava NAO segurava o botao do CAPINI KIT ([data-ck-cta]) — o seletor apontava pra um
   atributo inexistente e o kit reabilita o proprio botao. Agora: kit na lista + guarda de clique/submit em captura.
   Liga/desliga: metacampo capini.site_switches.model_gate (dashboard › Site, ou scripts/site/site-switch.py) — sem push de tema.
   v2.4 (10/09/2026 · canal site, Jobs): a v2.3 DOBRAVA o trabalho do celular (processador travado 18,8 s x 9,6 s sem a trava,
   medido no tema publicado). Saiu o MutationObserver (reaplica so apos clique/mudanca e em 3 passadas no load); iniciar() nao
   roda duas vezes (DOMContentLoaded + load disparavam 2 fetch = 2 observadores); enquanto falta o modelo o kit esconde o modelo
   herdado da pelicula/2a unidade (html[data-capini-model-pendente]).
   v2.5 (10/09/2026): escolher o mesmo modelo pre-marcado liberava o botao mas deixava o rotulo "Select your iPhone";
   agora o rotulo mostra o modelo escolhido.
   v2.6 (10/09/2026 20:3x): o Talles viu "Selecione seu iPhone: iPhone 18 Pro" em cima e "Selecione seu iPhone" na caixa (trocar a
   cor redesenha o seletor e trazia o modelo pre-marcado de volta na legenda). Agora: caixa diz "Choose your model", a legenda do
   modelo nao repete o valor (CSS), o rotulo e reaplicado apos o redesenho e o valor da legenda nao e mais apagado. */
/* =========================================================================
   capini-model-gate.js — a opção de MODELO nasce SEM nada escolhido
   -------------------------------------------------------------------------
   POR QUE EXISTE (medido em 04/09/2026)
   O cliente não seleciona o modelo errado — ele não seleciona NADA, e o tema
   entrega a primeira variante já marcada (quase sempre o iPhone 17 padrão).
   Varredura de 306 pedidos desde 01/07: 37 line items com iPhone 17 padrão,
   2 viraram reclamação (#1805 Mike King · #1753 Nanna). Cada caso custa a peça
   paga duas vezes ao fornecedor + frete + a errada perdida.

   O QUE FAZ
   Na página do produto, apaga a APARÊNCIA de "já escolhido" na opção de MODELO
   e trava o botão de compra até o cliente escolher de fato. A COR fica como
   está (martelo do Talles 04/09 — e o dado apoia: zero casos de cor errada no
   error-log do CS; a cor tem feedback visual, o modelo não tem nenhum).

   DUAS DECISOES DE PROJETO, E O PORQUE
   1) NAO mexe no valor que vai pro formulario. Zerar o input[name=optionN]
      faria o form enviar variante vazia se este script falhasse — um erro no
      carrinho, pior que o problema original. Mexemos so no visivel + na trava.
      Consequencia: preco e foto continuam intactos ao abrir a pagina.
   2) NAO le o nome da opcao pelo texto da tela. O storefront e traduzido pelo
      navegador do cliente ("Color:" vira "Cor:"), o que quebraria a deteccao.
      O nome canonico vem de /products/<handle>.js, sempre em ingles.

   NAO toca em snippets/foxify-*.liquid — regerados pelo app a qualquer momento.

   FALHA SEGURA: qualquer erro aqui devolve a loja ao comportamento antigo
   (variante pre-selecionada, botao liberado). Nunca deixa a pagina sem botao.
   ========================================================================= */
(function () {
  'use strict';

  var MARCA = 'capini-model-gate';

  /* --- 1. Que opcao e "modelo"? ------------------------------------------
     Nomes canonicos medidos no catalogo (79 produtos, /products.json 06/09):
       modelo -> Select your iPhone (23) · Model (6) · Compatibility by Model (7)
                 Select your Apple Watch (7) · Select your MacBook (3)
                 Compatible-Phone Models (2) · Select your laptop (1)
                 Material|Compatibility by Model (1)
       nao    -> Color/Colour · Size · Material · Capacity · Buckle · Bundle
                 Colour and Buckle · Leather and Hardware · Default Title     */

  var NUNCA = ['color', 'colour', 'size', 'material', 'capacity', 'buckle',
               'bundle', 'colour and buckle', 'color and buckle',
               'leather and hardware', 'default title'];

  function normaliza(s) {
    return String(s || '')
      .replace(/:\s*$/, '')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .trim().toLowerCase();
  }

  function ehModelo(nome) {
    var n = normaliza(nome);
    if (!n) return false;
    if (NUNCA.indexOf(n) !== -1) return false;          // igualdade exata, nunca "contem"
    return /\bmodel/.test(n) || /^select your\b/.test(n) || /compatib/.test(n);
  }

  /* --- 2. Estado -------------------------------------------------------- */

  var campos = [];
  var ligado = false;
  var iniciando = false;   /* v2.4: DOMContentLoaded e load chamam iniciar(); sem esta flag o fetch saia 2x e tudo duplicava */

  /* --- 3. Apagar a aparencia de "ja escolhido" --------------------------
     Tres formatos convivem no tema:
       a) dropdown custom -> <button class="select"><span id="...-selected-value">
       b) radios          -> input[type=radio][name=optionN]
       c) select nativo   -> select[name=optionN]                            */

  function rotuloPlaceholder(nome) {
    /* v2.6: a legenda ja diz "Select your iPhone:"; repetir o mesmo texto na caixa era a duplicacao que o Talles viu (10/09) */
    return 'Choose your model';
  }

  function apagarAparencia(fs, nome) {
    var texto = rotuloPlaceholder(nome);
    var mexeu = false;

    /* v2.6: o valor da legenda (variant-option-value) NAO e mais apagado — o tema o redesenha a cada troca de cor
       e apps de imagem por variante podem ler esse texto. Ele some por CSS so na opcao de modelo (ver iniciar). */

    var span = fs.querySelector('button.select span[id$="-selected-value"]')
            || fs.querySelector('button.select span');
    if (span) {
      if (!span.hasAttribute('data-capini-original')) {
        span.setAttribute('data-capini-original', span.textContent.trim());
      }
      span.textContent = texto;
      span.style.opacity = '.6';
      mexeu = true;
    }

    var opcoes = fs.querySelectorAll('[role="option"][aria-selected="true"]');
    for (var i = 0; i < opcoes.length; i++) {
      opcoes[i].setAttribute('aria-selected', 'false');
      mexeu = true;
    }

    var radios = fs.querySelectorAll('input[type="radio"]');
    if (radios.length > 1) {
      for (var j = 0; j < radios.length; j++) {
        if (radios[j].checked) { radios[j].checked = false; mexeu = true; }
      }
    }

    var sel = fs.querySelector('select');
    if (sel && sel.options.length > 1 && !sel.querySelector('option[data-capini-placeholder]')) {
      var ph = document.createElement('option');
      ph.value = ''; ph.textContent = '- ' + texto + ' -';
      ph.setAttribute('data-capini-placeholder', '1');
      sel.insertBefore(ph, sel.firstChild);
      ph.selected = true;
      mexeu = true;
    }

    return mexeu;
  }

  /* --- 4. Trava e aviso -------------------------------------------------- */

  function botoesDeCompra() {
    var lista = [];
    /* v2.3 (10/09): '[data-capini-kit-atc]' NAO EXISTE no tema — o botao do CAPINI KIT mora em [data-ck-cta].
       Medido no rascunho: com a v2.2 o "Adicionar 1 item" da Ferrara pos Brown / iPhone 17 no carrinho sem escolha. */
    var seletores = ['buy-buttons button[type="submit"]',
                     'form[action*="/cart/add"] button[type="submit"]',
                     '.shopify-payment-button button',
                     '[data-ck-cta] button'];
    for (var s = 0; s < seletores.length; s++) {
      var achados = document.querySelectorAll(seletores[s]);
      for (var i = 0; i < achados.length; i++) {
        if (lista.indexOf(achados[i]) === -1) lista.push(achados[i]);
      }
    }
    return lista;
  }

  function aviso(fs, texto) {
    var alvo = fs.querySelector('.variant-picker__option-info') || fs;
    var el = fs.querySelector('[data-capini-gate-aviso]');
    if (!texto) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('p');
      el.setAttribute('data-capini-gate-aviso', '1');
      el.style.cssText = 'margin:.4rem 0 0;font-size:.8125rem;line-height:1.35;opacity:.75';
      alvo.appendChild(el);
    }
    if (el.textContent !== texto) el.textContent = texto; /* v2: so escreve se mudou (a escrita repetida retroalimentava o MutationObserver = laco infinito, 06-07/09) */
  }

  /* v2.1: detectar a escolha pelo que o TEMA mostra, nao so pelo clique (no celular a lista de opcoes abre fora do fieldset,
     e o clique nunca chegava ao fieldset -> a trava nao destravava). Se o texto do seletor deixou de ser o placeholder,
     ou um radio ficou marcado, o cliente escolheu. */
  /* v2.2: sem deteccao por texto (a pagina e traduzida pelo Google Tradutor: o rotulo muda sem o cliente escolher).
     So conta radio marcado ou <select> com valor — os caminhos de escolha reais estao em ouvir(). */
  function detectarEscolha(c) {
    if (c.escolheu) return true;
    try {
      if (c.fieldset.querySelector('input[type="radio"]:checked')) c.escolheu = true;
      var sel = c.fieldset.querySelector('select');
      if (sel && sel.value) c.escolheu = true;
    } catch (e) {}
    return c.escolheu;
  }

  function aplicar() {
    var faltam = 0;
    for (var i = 0; i < campos.length; i++) {
      var c = campos[i];
      /* v2.6: trocar a cor faz o tema REDESENHAR o seletor (fieldset novo). Reencontra pela ancora estavel e reaplica o rotulo. */
      var ancora = document.querySelector('variant-picker[handle] variant-option-value[for="option' + c.indice + '"]');
      var fsAtual = ancora ? ancora.closest('fieldset') : null;
      if (fsAtual && fsAtual !== c.fieldset) c.fieldset = fsAtual;
      detectarEscolha(c);
      if (c.escolheu) { aviso(c.fieldset, ''); continue; }
      faltam++;
      var sp = c.fieldset.querySelector('button.select span[id$="-selected-value"]');
      var ph = rotuloPlaceholder(c.nome);
      if (sp && sp.textContent !== ph) { sp.textContent = ph; sp.style.opacity = '.6'; }
      aviso(c.fieldset, 'Choose yours to continue.');
    }

    var raiz = document.documentElement;
    if (faltam) { if (!raiz.hasAttribute('data-capini-model-pendente')) raiz.setAttribute('data-capini-model-pendente', '1'); }
    else if (raiz.hasAttribute('data-capini-model-pendente')) raiz.removeAttribute('data-capini-model-pendente');

    var botoes = botoesDeCompra();
    for (var k = 0; k < botoes.length; k++) {
      var b = botoes[k];
      if (faltam) {
        if (!b.hasAttribute('data-capini-gate-travado')) {
          b.setAttribute('data-capini-gate-travado', '1');
          b.setAttribute('aria-disabled', 'true');
          b.disabled = true;
          b.style.opacity = '.45';
          b.style.cursor = 'not-allowed';
        }
      } else if (b.hasAttribute('data-capini-gate-travado')) {
        b.removeAttribute('data-capini-gate-travado');
        b.removeAttribute('aria-disabled');
        b.disabled = false;
        b.style.opacity = '';
        b.style.cursor = '';
      }
    }
  }

  /* --- 5. Ouvir a escolha do cliente ------------------------------------ */

  function marcarEscolhido(fs, valor) {
    for (var i = 0; i < campos.length; i++) {
      if (!campos[i].escolheu && (campos[i].fieldset === fs || fs.querySelector('variant-option-value[for="option' + campos[i].indice + '"]'))) {
        campos[i].escolheu = true;
        /* v2.5: escolher o MESMO modelo que vinha marcado nao dispara mudanca no tema, entao o rotulo ficava
           "Select your iPhone" com o botao ja liberado (visto no Chrome do Talles 10/09). Agora o rotulo recebe o valor escolhido. */
        if (!valor) {
          var inp = fs.querySelector('input[type="radio"]:checked') || fs.querySelector('select') || fs.querySelector('input[type="hidden"][name^="option"]');
          valor = inp ? String(inp.value || '').trim() : '';
        }
        var span = fs.querySelector('button.select span[id$="-selected-value"]');
        if (span) {
          span.style.opacity = '';
          if (valor && span.textContent.trim() !== valor) span.textContent = valor;
        }
        var vov = fs.querySelector('variant-option-value');
        if (vov && !vov.textContent.trim()) vov.textContent = valor || vov.getAttribute('data-capini-original') || '';
        aplicar();
        return;
      }
    }
  }

  var houveGesto = false;
  function fieldsetDaOpcao(el) {
    var fs = el.closest('fieldset');
    if (fs) return fs;
    /* v2.2: no Impact a lista de opcoes (x-popover) fica no <body>, fora do fieldset; a ponte e o aria-controls do botao */
    var pop = el.closest('[id^="popover"], x-popover, .popover');
    if (pop && pop.id) {
      var btn = document.querySelector('button.select[aria-controls="' + pop.id + '"]');
      if (btn) return btn.closest('fieldset');
    }
    return null;
  }
  function ouvir() {
    ['pointerdown', 'touchstart', 'keydown'].forEach(function (n) {
      document.addEventListener(n, function () { houveGesto = true; }, true);
    });
    document.addEventListener('click', function (ev) {
      if (!ev.target || !ev.target.closest) return;
      // so conta como escolha o clique numa OPCAO (mesmo que seja a que ja vinha marcada) — nao em abrir o dropdown
      var opt = ev.target.closest('[role="option"], label[for], .popover-listbox__option');
      if (!opt) return;
      var fs = fieldsetDaOpcao(opt);
      var valor = String(opt.getAttribute('value') || opt.textContent || '').trim();
      if (fs) setTimeout(function () { marcarEscolhido(fs, valor); }, 40);
    }, true);
    document.addEventListener('change', function (ev) {
      if (!ev.target || !ev.target.closest) return;
      var fs = ev.target.closest('fieldset');
      if (fs && houveGesto) marcarEscolhido(fs);
    }, true);
    /* o tema dispara variant:change no form quando a variante muda: se veio depois de um gesto do cliente, ele escolheu */
    document.addEventListener('variant:change', function () {
      if (!houveGesto) return;
      for (var i = 0; i < campos.length; i++) campos[i].escolheu = true;
      aplicar();
    }, true);
    /* v2.3: GUARDA NO CLIQUE, fase de captura no document (roda ANTES do listener do <capini-kit>).
       O disabled sozinho nao segura o kit: ele liga/desliga o proprio botao no loading (capini-kit.js setLoading)
       e o observador nao olha atributo. Sem modelo escolhido: o clique morre aqui, o aviso aparece e a tela rola ate o seletor. */
    function pendente() {
      for (var i = 0; i < campos.length; i++) { detectarEscolha(campos[i]); if (!campos[i].escolheu) return campos[i]; }
      return null;
    }
    function segurar(ev) {
      var c = pendente();
      if (!c) return false;
      ev.preventDefault();
      ev.stopImmediatePropagation();
      aviso(c.fieldset, 'Choose yours to continue.');
      try { c.fieldset.scrollIntoView({ block: 'center' }); } catch (e) {}
      return true;
    }
    document.addEventListener('click', function (ev) {
      if (!ev.target || !ev.target.closest) return;
      if (ev.target.closest('[data-ck-cta], buy-buttons button[type="submit"], form[action*="/cart/add"] button[type="submit"], .shopify-payment-button')) segurar(ev);
    }, true);
    document.addEventListener('submit', function (ev) {
      var f = ev.target;
      if (f && f.getAttribute && /\/cart\/add/.test(f.getAttribute('action') || '')) segurar(ev);
    }, true);
  }

  /* --- 6. Ligar --------------------------------------------------------- */

  function iniciar() {
    if (ligado || iniciando) return;

    // Quem chegou por link com a variante ja escolhida (anuncio, catalogo Meta,
    // e-mail, "comprar de novo") NAO passa pelo gate: ele ja decidiu.
    if (/[?&]variant=\d+/.test(window.location.search)) return;

    var picker = document.querySelector('variant-picker[handle]');
    if (!picker) return;
    if (!document.querySelector('form[action*="/cart/add"]')) return;

    var handle = picker.getAttribute('handle');
    if (!handle) return;

    iniciando = true;
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (prod) {
        if (!prod || !prod.options || !prod.options.length) return;

        var fieldsets = picker.querySelectorAll('fieldset');
        for (var i = 0; i < prod.options.length; i++) {
          var nome = typeof prod.options[i] === 'string' ? prod.options[i] : prod.options[i].name;
          if (!ehModelo(nome)) continue;

          // casa o fieldset por variant-option-value[for="optionN"] — imune a traducao
          var ancora = picker.querySelector('variant-option-value[for="option' + (i + 1) + '"]');
          var fs = ancora ? ancora.closest('fieldset') : fieldsets[i];
          if (!fs) continue;

          // opcao com um valor so: nao ha o que escolher
          var valores = {};
          if (prod.variants) {
            for (var v = 0; v < prod.variants.length; v++) {
              valores[prod.variants[v]['option' + (i + 1)]] = 1;
            }
          }
          if (Object.keys(valores).length < 2) continue;

          if (apagarAparencia(fs, nome)) {
            campos.push({ fieldset: fs, indice: i + 1, nome: nome, escolheu: false });
          }
        }

        if (!campos.length) return;
        ligado = true;
        /* v2.4: enquanto falta o modelo, o kit nao mostra o modelo "herdado" da variante pre-selecionada
           (a linha da pelicula dizia "iPhone 17" com o seletor vazio). Depois da escolha o kit casa a pelicula sozinho. */
        try {
          var st = document.createElement('style');
          st.textContent = 'html[data-capini-model-pendente] [data-ck-mirror],html[data-capini-model-pendente] [data-ck-choices]{visibility:hidden}' +
            /* v2.6: a legenda do MODELO nao repete o valor ("Select your iPhone: iPhone 18 Pro") — a caixa logo abaixo ja mostra */
            campos.map(function (c) { return 'variant-picker variant-option-value[for="option' + c.indice + '"]{display:none!important}'; }).join('');
          document.head.appendChild(st);
        } catch (e) {}
        ouvir();
        aplicar();

        /* v2.4 (10/09/2026): SEM MutationObserver. Medido no tema publicado: com o observador na .product-info o celular
           ficava com o processador travado 18,8 s por visita contra 9,6 s sem a trava (o kit e os apps mexem no DOM o tempo
           todo e cada mexida reagendava aplicar()). Quem segura a compra e a guarda de clique em captura (v2.3); o visual
           da trava e reaplicado so quando importa: depois de clique/mudanca e em 3 passadas no carregamento. */
        var agendado = null;
        function reaplicar() {
          if (agendado) return;
          var falta = false;
          for (var q = 0; q < campos.length; q++) { if (!campos[q].escolheu) { falta = true; break; } }
          if (!falta) return;
          agendado = setTimeout(function () { agendado = null; try { aplicar(); } catch (e) {} setTimeout(function () { try { aplicar(); } catch (e) {} }, 650); }, 150);
        }
        document.addEventListener('click', reaplicar, true);
        document.addEventListener('change', reaplicar, true);
        [700, 2000, 4500].forEach(function (ms) { setTimeout(reaplicar, ms); });

        document.documentElement.setAttribute('data-' + MARCA, 'on');
      })
      .catch(function (e) {
        if (window.console && console.warn) console.warn('[' + MARCA + '] desligado:', e);
      });
  }

  function seguro() {
    try { iniciar(); } catch (e) {
      // Silencioso de proposito: a loja volta ao comportamento antigo e continua
      // vendendo. Um gate quebrado nunca pode tirar o botao da tela.
      if (window.console && console.warn) console.warn('[' + MARCA + '] desligado:', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', seguro);
  } else {
    seguro();
  }
  window.addEventListener('load', function () { setTimeout(seguro, 300); });
})();
